import React, {FC} from "react";
import {ReactQueryDevtools} from '@tanstack/react-query-devtools'
import {isDebug, isDev} from "../../utils/EnvironmentUtils";
import AppDebugStateViewer from "../../components/AppDebugStateViewer/AppDebugStateViewer";

const DeveloperProvider: FC = () => {
    return (
        <>
            <ReactQueryDevtools initialIsOpen={isDev()}/>

            {
                isDev() && isDebug() &&
                <AppDebugStateViewer/>
            }
        </>
    )
}

export default DeveloperProvider;
